export enum EMatchTypeQueryKey {
  MATCH_TYPES = 'match-types'
}
